import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetRunResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (data: GetRunResponse) => ReactElement
}

const GetAiRunRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiRunRequest
